
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '@/components/admin/AdminLayout';

const CoursesManagementPage: React.FC = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect to the functional courses list page
    navigate('/admin/courses/list');
  }, [navigate]);

  return (
    <AdminLayout>
      <div className="container py-10">
        <p>Redirecting to courses management...</p>
      </div>
    </AdminLayout>
  );
};

export default CoursesManagementPage;
